import { trackQualifiedListen } from '~/productAnalytics';

/** One qualified listen per mounted episode, after 30 seconds of actual playback. */
export default class TrackListening {
    private elapsed = 0;
    private startedAt: number | null = null;
    private timer: ReturnType<typeof setTimeout> | undefined;
    private tracked = false;

    private sessionStarted = false;

    constructor(
        private readonly qualified: () => void = () => undefined,
        private readonly beginSession: () => void = () => undefined,
    ) {}

    start(): void {
        if (this.startedAt !== null || this.tracked) return;
        if (!this.sessionStarted) {
            this.beginSession();
            this.sessionStarted = true;
        }
        this.startedAt = performance.now();
        this.timer = setTimeout(
            () => {
                this.tracked = true;
                this.pause();
                this.qualified();
                void trackQualifiedListen();
            },
            Math.max(0, 30_000 - this.elapsed),
        );
    }

    pause(): void {
        if (this.startedAt !== null) {
            this.elapsed += performance.now() - this.startedAt;
            this.startedAt = null;
        }
        clearTimeout(this.timer);
        this.timer = undefined;
    }

    end(): void {
        this.pause();
        this.elapsed = 0;
        this.tracked = false;
        this.sessionStarted = false;
    }

    destroy(): void {
        this.pause();
    }
}
